import { NativeModules } from 'react-native';

const { NavigationModule } = NativeModules;

export const dismissViewController = async (): Promise<void> => {
  await NavigationModule?.dismiss();
};

export const canDismiss = () => !!NavigationModule;
